<template>
<div>
  <div class="container" v-if="updateUserEmailResponse">
    <div v-if="!securityCodeSuccess">
      <security-code-verification ref="refSecurityCodeVerification"
                                      @isSecurityCodeSuccess="isSecurityCodeSuccess($event)" />
    </div>
    <div v-else>
        <div tabindex="0" class="e-card" id="basic">
          <div class="e-card-title">Success</div>
          <div class="e-card-separator"></div>
            <div class="e-card-content margin-color-verify-section">
                 <p>
                    Your email has been verified.
                    You can now login to your account using your new email by clicking
                    <ejs-button
                        cssClass="e-link"
                        v-on:click.native="login"
                        style="padding: 3px">
                        here
                    </ejs-button>
                    or using the Sign In button.
                </p>
            </div>
          </div>
    </div>
  </div>
  <div class="container" v-if="chnagePasswordResponse">
      <div tabindex="0" class="e-card" id="basic">
          <div class="e-card-title">Success</div>
          <div class="e-card-separator"></div>
            <div class="e-card-content margin-color-verify-section">
                 <p>
                   Confirmation email sent to registered email id.
                   Please click here to
                   <ejs-button
                        cssClass="e-link"
                        v-on:click.native="login"
                        style="padding: 3px"
                      >
                        Login
                      </ejs-button>
                    with new credentials.
                </p>
            </div>
          </div>
  </div>
</div>
</template>

<script>
import {
  SIGN_USER_OUT,
} from '../modules/auth/store';
import SecurityCodeVerification from '../modules/auth/components/security-code-verification.vue';

export default {
  name: 'EmailSent',
  components: {
    SecurityCodeVerification,
  },
  data() {
    return {
      securityCodeSuccess: false,
    };
  },
  created() {
    this.logOut('SUCCESS');
  },
  computed: {
    updateUserEmailResponse() {
      return this.$store.getters.updateUserEmailResponse;
    },
    chnagePasswordResponse() {
      return this.$store.getters.chnagePasswordResponse;
    },
  },
  watch: {
    updateUserEmailResponse(val) {
      if (val === 'SUCCESS') this.logOut(val);
    },
    chnagePasswordResponse(val) {
      if (val === 'SUCCESS') this.logOut(val);
    },
  },
  methods: {
    logOut(val) {
      if (val === 'SUCCESS') {
        this.$store.dispatch(SIGN_USER_OUT);
        this.isEmailSent = true;
      } else this.isEmailSent = false;
    },
    login() {
      this.$router.push('/login');
    },
    isSecurityCodeSuccess(event) {
      if (event) this.securityCodeSuccess = event.isSuccess;
    },
  },
};
</script>
<style>
.container {
  padding: 16px 25% 16px 25%;
}
.e-card-title{
  background: #0f4b90;
  color: white;
}
</style>
